import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { alertDialog } from '@adornis/dialog/dialog-functions.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { GlobalConfigAPI } from '@martinus/global-config/api/GlobalConfigAPI.js';
import { SGConfig } from '@martinus/global-config/db/sg-config.js';
import { html } from 'lit';

const DownloadArea = stateful((props: { title: string; formKey: string; config: SGConfig }) => {
  return html`
    <button
      type="button"
      class="btn btn-dash btn-block justify-between"
      @click=${async () => {
        if (!props.config[props.formKey]) {
          await alertDialog(
            'Keine Datei hinterlegt! Bitte kontaktieren Sie einen Administrator unter info@martinus.sg!',
          );
          return;
        }
        goTo(AdornisFile.getServeLink(props.config[props.formKey]), { target: '_blank' });
      }}
    >
      <span class="font-semibold text-sm">${props.title}</span>
      <span class="icon-[material-symbols--download-rounded] size-5 text-base-content/70"></span>
    </button>
  `;
});

export const EmployeeSectionDownloadsForm = stateful(() => {
  const { value: config, loading } = useQuery(() => GlobalConfigAPI.subscribe()(selectionSet(() => SGConfig, 1)), []);

  if (!config || loading) return html`<span class="loading loading-spinner"></span>`;

  return html`
    <div class="flex flex-col gap-2">
      <p class="font-semibold text-sm text-base-content/70 mb-1">
        Nachstehende Downloads stehen als Information zur Verfügung:
      </p>
      <a href="https://bistummainz.de/organisation/praevention/index.html" target="_blank" class="no-underline">
        <span class="btn btn-dash btn-block justify-between">
          <span class="font-semibold text-sm">Prävention des Bistums Mainz</span>
          <span class="icon-[material-symbols--open-in-new-rounded] size-5 text-base-content/70"></span>
        </span>
      </a>
      ${DownloadArea({
        title: 'Information zur Kirchlichen Zusatzversorgungskasse',
        formKey: 'kzvkID',
        config: config as SGConfig,
      })}
      ${DownloadArea({ title: 'Kirchliches Amtsblatt', formKey: 'kirchlichesAmtsblattID', config: config as SGConfig })}
      ${DownloadArea({
        title: 'Kirchliches Datenschutzgesetz',
        formKey: 'kirchlichesDatenschutzgesetzID',
        config: config as SGConfig,
      })}
      ${DownloadArea({
        title: 'Informationen für Mitarbeiter',
        formKey: 'infosFuerMitarbeiterID',
        config: config as SGConfig,
      })}
    </div>
  `;
});
